import React, { useEffect } from "react";
import { useBreadcrumbs } from "@/components/provider/BreadcrumbsProvider";
import { useNavigate, useSearchParams } from "react-router-dom";
import { usePostAuthSalesforceMutation } from "@/store/rest_api";

const SalesforceCallback = () => {
  const { setPage, setSection } = useBreadcrumbs();
  const navigate = useNavigate();
  const [queryParams] = useSearchParams();
  const [postAuthSalesforce, postAuthSalesforceResponse] = usePostAuthSalesforceMutation();

  useEffect(() => {
    setSection("Integrations");
    setPage("Salesforce");
  }, []);

  useEffect(() => {
    const authzCode = queryParams.get("code");
    const integrationId = queryParams.get("state");
    if (authzCode && integrationId) {
      postAuthSalesforce({ code: authzCode, integrationId });
    }
  }, []);

  useEffect(() => {
    if (postAuthSalesforceResponse.isError || postAuthSalesforceResponse.isSuccess) {
      const timer = setTimeout(() => {
        navigate("/integrations");
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [postAuthSalesforceResponse.isError]);

  if (postAuthSalesforceResponse.isSuccess) {
    return <div>Success! Redirecting...</div>;
  }

  if (postAuthSalesforceResponse.isError) {
    return <div>Failure, redirecting... </div>;
  }

  return <div>Salesforce callback</div>;
};

export default SalesforceCallback;
